import React, { useState, useEffect, useContext, useCallback } from "react";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { ToastContainer } from "react-toastify";
import PayrollTableWithButton from "./PayrollTableWithButton";
import useSwal from "../../../common/ReusableComponent/useSwal";
import { capitalizeFirstLetter } from "../../../../utils/helper/common";
import { useToastHandler } from "../../../common/ToastHandler";
import useFormattedDate from "../../../../context/useFormattingUtils";
import ChequeRenderer from '../../AppPAges/Payroll/Cheque Layout/ChequeRenderer'
import {
  RegularButton,
} from "../../../common/ReusableComponent/CustomButton";
import {
  ReusableDateInput,
  ReusableInput,
  SelectInput,
} from "../../../common/ReusableComponent/ReusableInput";
import ReusableModal from "../ManageSettings/ReusableModal";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";
import ScheduleModal from "./ScheduleModal";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ReciptPrint from "../../AppPAges/Payroll/SalaryRecipt";
// Biometric hours are pulled directly in this Payroll page using faceTotalWorkedHours API.
// Do not import BiometricController here. Keep BiometricController.js unchanged.


export default function Payroll() {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const [showModal, setShowModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [modalType, setModalType] = useState("new");
  const [payrollData, setPayrollData] = useState([]);
  const [selectedChequeLayout, setSelectedChequeLayout] = useState(null);
  const [, setSalaryHistory] = useState([]);
  const [selectedPayroll, setSelectedPayroll] = useState(null);
  const [bankdata, setBank] = useState([]);
  const [loading, setLoading] = useState(false);
  const { confirmDelete } = useSwal();
  const { handleToast } = useToastHandler();
  const [editingPayrollId, setEditingPayrollId] = useState(null);
  const { formatDate } = useFormattedDate();
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  const [, setEmailError] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [, setContactNoError] = useState("");
  const { Get, Post, Delete, Patch, _Get, getAPI, GetPaginatedData } = useApi();

  const [biometricCalculatedHours, setBiometricCalculatedHours] = useState(null);
  const [biometricDailyLog, setBiometricDailyLog] = useState([]);
  const [biometricLoading, setBiometricLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

const [printData, setPrintData] = useState(null);
const [openPrint, setOpenPrint] = useState(false);

/**
 * Biometric hours integration:
 * User stays in the manual payroll form and can optionally pull actual
 * worked hours from biometric attendance into paymentData.total_hour.
 */
const [useBiometricHours, setUseBiometricHours] = useState(false);
const [biometricHoursApplied, setBiometricHoursApplied] = useState(false);
const [selectedBiometricPayrollEmployee, setSelectedBiometricPayrollEmployee] = useState(null);

  const initialFormData = {
    type: "payroll",
    full_name: "",
    contact_no: "",
    email: "",
    date: new Date().toISOString().split("T")[0],
    status: "unpaid",
    pay_method_status: "",
    pay_method: "cash",
    pay_salary: "",
    bank: "",
    salary: null,
    deductions: null,
    net_salary: null,
    note: "",
    bank: "",
    bank_name: "",
  };

  const initialPaymentData = {
    store: storeId,
    payment_method: "cash",
    salary_amount: "",
    payment_date: new Date().toISOString().split("T")[0],
    bank: "",
    bank_name: "",
    salary_unit: "bi weekly",
    total_hour: "",
    start_date: "",
    end_date: "",
    note: "",
  };

  const DEFAULT_WORKING_DAYS = {
    M: false,
    T: false,
    W: false,
    Th: false,
    Fri: false,
    Sat: false,
    Sun: false,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [paymentData, setPaymentData] = useState(initialPaymentData);
  const [salaryHistoryRefreshKey, setSalaryHistoryRefreshKey] = useState(0);

  const [salaryHistoryPage, setSalaryHistoryPage] = useState(1);
  const [salaryHistoryTotalPages, setSalaryHistoryTotalPages] = useState(1);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [hourlyPayAmount, setHourlyPayAmount] = useState("");
  const [monthlyPayAmount, setMonthlyPayAmount] = useState("");
  const [employeeLeaves, setEmployeeLeaves] = useState("");
  const [allowedDailyHours, setAllowedDailyHours] = useState("8");
  // const [workingDays, setWorkingDays] = useState({
  //   M: false,
  //   T: false,
  //   W: false,
  //   Th: false,
  //   Fri: false,
  //   Sat: false,
  //   Sun: false
  // });
  const [workingDays, setWorkingDays] = useState(DEFAULT_WORKING_DAYS);

  const [paidDayOffLeaves, setPaidDayOffLeaves] = useState("");
  const [taxDeductionType, setTaxDeductionType] = useState("percentage");
  const [taxDeductionValue, setTaxDeductionValue] = useState("");
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [faceProfileId,] = useState(null);

const handlePrintSalary = (row) => {
  if (!row) return;


  setPrintData({
    ...row,
    store_info: row.store_info,
  });

  setOpenPrint(true);
};



  const calculateExpectedHours = () => {
    if (!paymentData.start_date || !paymentData.end_date) return 0;

    const startDate = new Date(paymentData.start_date);
    const endDate = new Date(paymentData.end_date);
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

    const holidaysCount = Object.values(workingDays).filter(day => day).length;
    const workingDaysPerWeek = Math.max(0, 7 - holidaysCount);
    const dailyHours = parseInt(allowedDailyHours) || 8;

    const weeks = Math.floor(daysDiff / 7);
    const remainingDays = daysDiff % 7;
    const totalWorkingDays = (weeks * workingDaysPerWeek) + Math.min(remainingDays, workingDaysPerWeek);
    const expectedHours = totalWorkingDays * dailyHours;

    return expectedHours;
  };

  const calculateWorkedHours = () => {
    if (!paymentData.start_date || !paymentData.end_date) return 0;

    const expectedHours = calculateExpectedHours();
    const leaves = parseInt(employeeLeaves) || 0;
    const paidLeaves = parseInt(paidDayOffLeaves) || 0;
    const dailyHours = parseInt(allowedDailyHours) || 8;

    // Adjust for leaves: subtract unpaid leaves, add back paid leaves
    const leaveAdjustment = (paidLeaves - leaves) * dailyHours;
    const workedHours = Math.max(0, expectedHours + leaveAdjustment);

    return workedHours;
  };


  useEffect(() => {
    if (useBiometricHours) return;

    if (paymentData.start_date && paymentData.end_date) {
      const calculatedHours = calculateWorkedHours();
      setPaymentData(prev => ({
        ...prev,
        total_hour: calculatedHours.toString()
      }));
    }
  }, [paymentData.start_date, paymentData.end_date, allowedDailyHours, employeeLeaves, workingDays, paidDayOffLeaves, useBiometricHours]);


  const calculatePreview = () => {
    const amount = parseFloat(paymentData.salary_amount) || 0;
    const totalHours = parseFloat(paymentData.total_hour) || 0;
    const dailyHours = parseInt(allowedDailyHours) || 8;
    const leaves = parseInt(employeeLeaves) || 0;
    const paidLeaves = parseInt(paidDayOffLeaves) || 0;
    const holidaysCount = Object.values(workingDays).filter(day => day).length;

    let grossSalary = 0;
    let calculationDetails = {};

    if (paymentData.salary_unit === "hourly") {
      grossSalary = totalHours * amount;
      calculationDetails = {
        totalHours,
        hourlyRate: amount,
        calculation: `${totalHours} hours × $${amount} = $${grossSalary.toFixed(2)}`
      };
    } else {
      const startDate = new Date(paymentData.start_date);
      const endDate = new Date(paymentData.end_date);
      const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
      const workingDaysPerWeek = Math.max(0, 7 - holidaysCount);
      const weeks = Math.floor(daysDiff / 7);
      const remainingDays = daysDiff % 7;
      const totalWorkingDays = (weeks * workingDaysPerWeek) + Math.min(remainingDays, workingDaysPerWeek);
      const adjustedWorkingDays = Math.max(0, totalWorkingDays - leaves + paidLeaves);

      // Calculate daily rate and adjust gross salary based on actual working days
      const dailyRate = amount / totalWorkingDays;
      grossSalary = adjustedWorkingDays * dailyRate;

      calculationDetails = {
        dateRange: `${paymentData.start_date} to ${paymentData.end_date}`,
        totalDays: daysDiff,
        holidaysPerWeek: holidaysCount,
        workingDaysPerWeek,
        totalWorkingDays,
        employeeLeaves: leaves,
        paidLeaves,
        adjustedWorkingDays,
        dailyHours,
        totalHours,
        dailyRate: dailyRate.toFixed(6),
        calculation: `${adjustedWorkingDays} days × $${dailyRate.toFixed(6)} = $${grossSalary.toFixed(2)}`
      };
    }

    let deduction = 0;
    if (taxDeductionValue) {
      deduction = taxDeductionType === "percentage"
        ? (grossSalary * parseFloat(taxDeductionValue)) / 100
        : parseFloat(taxDeductionValue);
    }

    const netSalary = grossSalary - deduction;

    return {
      ...calculationDetails,
      rate: amount,
      unit: paymentData.salary_unit,
      grossSalary: grossSalary.toFixed(2),
      deduction: deduction.toFixed(2),
      netSalary: netSalary.toFixed(2),
      taxType: taxDeductionType,
      taxValue: taxDeductionValue
    };
  };

  //Cheque preview data (for preview chequerenderer)
  const chequePreviewData = (() => {
    const preview = calculatePreview();
    return {
      name: selectedPayroll?.full_name || "",
      amount: preview?.netSalary || "0.00",
      date: paymentData.payment_date || new Date().toISOString().split('T')[0],
      chequeNumber: paymentData.cheque_no || "",
    };
  })();



  useEffect(() => {
    if (hourlyPayAmount && !monthlyPayAmount) {
      setPaymentData(prev => ({ ...prev, salary_unit: "hourly" }));
    } else if (monthlyPayAmount && !hourlyPayAmount) {
      setPaymentData(prev => ({ ...prev, salary_unit: "monthly" }));
    }
  }, [hourlyPayAmount, monthlyPayAmount]);

  const clearForm = () => {
    setFormData(initialFormData);
    setEmail("");
    setEmailError("");
    setContactNo("");
    setContactNoError("");
    setErrors({});
  };

  const validateFullName = (name) => {
    if (!name.trim()) {
      return "Employee name is required";
    }
    return "";
  };

  const validateContactNo = (number) => {
    const contactRegex = /^[0-9]{10}$/;
    if (!number) {
      return "Contact number is required";
    } else if (!contactRegex.test(number)) {
      return "Invalid contact number format: must be exactly 10 digits and contain no letters";
    }
    return "";
  };

  const validateEmail = (email) => {
    const emailRegex = /^[\w.\-]+\s*@\s*[a-zA-Z][a-zA-Z\d.\-]*\.[a-zA-Z]{2,}$/;
    if (!email) {
      return "Email is required";
    } else if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const handleFullNameChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, full_name: value }));
    setErrors((prev) => ({ ...prev, full_name: validateFullName(value) }));
  };

  const handleContactNoChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 14);
    setContactNo(value);
    setFormData((prev) => ({ ...prev, contact_no: value }));
    setErrors((prev) => ({ ...prev, contact_no: validateContactNo(value) }));
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setFormData((prev) => ({ ...prev, email: value }));
    setErrors((prev) => ({ ...prev, email: validateEmail(value) }));
  };

  const handleModalClose = () => {
    closeModal();
    setErrors({});
  };

  const formattedPayrollData = payrollData.map((item) => ({
    ...item,
    date: formatDate(item.date),
  }));

  useEffect(() => {
    fetchBankData();
  }, []);

  useEffect(() => {
    fetchPayrollData({ page: 1, searchTerm: "" });
  }, []);

  const fetchPayrollData = async ({
    page = 1,
    searchTerm = "",
    sort = "",
  } = {}) => {
    try {

      const response = await GetPaginatedData("payrollEmployeeData", {
        page,
        search: searchTerm || undefined,
        queryParams: {
          ...(sort && { sort }),
        },
      });

      const results = response?.data || [];
      const count = response?.totalCount || 0;
      const totalPages = Math.ceil(count / 10);
      setPayrollData(results);
      setTotalPages(totalPages);
      setCurrentPage(page);

      return { data: results, totalPages };
    } catch (error) {
      console.error("Error fetching payroll data:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch payroll data.",
      });
      return { data: [], totalPages: 1 };
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = useCallback(
    (page) => {
      fetchPayrollData({ page, searchTerm });
    },
    [searchTerm]
  );

  const handleSearch = useCallback((newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    fetchPayrollData({ page: 1, searchTerm: newSearchTerm });
  }, []);

 const fetchSalaryHistory = async ({
  page = salaryHistoryPage,
  searchTerm = "",
} = {}) => {

  const res = await GetPaginatedData("payrollSalaryData", {
    page,
    search: searchTerm,
  });

  const newTotalPages = Math.ceil((res.totalCount || 0) / 10);
  if (salaryHistoryTotalPages !== newTotalPages) {
    setSalaryHistoryTotalPages(newTotalPages);
  }

  const storeInfo = res.rawResponse?.store_info || {};

  const filteredData = (res.data || [])
    .map((item) => ({
      ...item,
      salary_source: item.is_bio ? "Biometric" : "Manual",
      store_info: storeInfo,
    }));

  return {
    data: filteredData,
    totalPages: newTotalPages,
  };
};

  const fetchBankData = async () => {
    try {
      const response = await Get("bank");
      const bankList = response?.results || [];
      setBank(bankList);
    } catch (error) {
      console.error("Error fetching bank data:", error);

      handleToast({
        type: "ERROR",
        message: "Failed to fetch bank data.",
      });
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalType("new");
    setFormData(initialFormData);
    setPaymentData(initialPaymentData);
    setEditingPayrollId(null);
    setSelectedPayroll(null);
    setSelectedChequeLayout(null);
    setSelectedDateRange(null);
    setHourlyPayAmount("");
    setMonthlyPayAmount("");
    setEmployeeLeaves("");
    setAllowedDailyHours("");
    setWorkingDays({
      M: false,
      T: false,
      W: false,
      Th: false,
      Fri: false,
      Sat: false,
      Sun: false
    });
    setPaidDayOffLeaves("");
    setTaxDeductionType("percentage");
    setTaxDeductionValue("");
    setUseBiometricHours(false);
    setBiometricHoursApplied(false);
    setSelectedBiometricPayrollEmployee(null);
    setBiometricCalculatedHours(null);
    setBiometricDailyLog([]);
    setBiometricLoading(false);
  };

  const clearPaymentForm = () => {
    setPaymentData(initialPaymentData);
  };

  const getDateRanges = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    const pad = (num) => String(num).padStart(2, '0');

    const formatDate = (date) => {
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    };

    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    const weekStart = new Date(today);
    weekStart.setDate(today.getDate() - daysToMonday);

    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    const biWeeklyStart = new Date(weekStart);

    const biWeeklyEnd = new Date(weekStart);
    biWeeklyEnd.setDate(weekStart.getDate() + 13);

    const currentStart = `${year}-${pad(month + 1)}-01`;
    const currentLastDay = new Date(year, month + 1, 0).getDate();
    const currentEnd = `${year}-${pad(month + 1)}-${pad(currentLastDay)}`;

    const prevYear = month === 0 ? year - 1 : year;
    const prevMonth = month === 0 ? 12 : month;
    const prevStart = `${prevYear}-${pad(prevMonth)}-01`;
    const prevLastDay = new Date(prevYear, prevMonth, 0).getDate();
    const prevEnd = `${prevYear}-${pad(prevMonth)}-${pad(prevLastDay)}`;

    return {
      currentWeek: {
        start: formatDate(weekStart),
        end: formatDate(weekEnd)
      },
      biWeekly: {
        start: formatDate(biWeeklyStart),
        end: formatDate(biWeeklyEnd)
      },
      thisMonth: {
        start: currentStart,
        end: currentEnd
      },
      previousMonth: {
        start: prevStart,
        end: prevEnd
      }
    };
  };

  const setDateRange = (range) => {
    const ranges = getDateRanges();
    setSelectedDateRange(range);

    let salaryUnit = "hourly";
    let startDate = new Date().toISOString().split("T")[0];
    let endDate = new Date().toISOString().split("T")[0];

    if (range === 'hourly') {
      salaryUnit = "hourly";
    } else if (range === 'currentWeek') {
      salaryUnit = "weekly";
      startDate = ranges[range].start;
      endDate = ranges[range].end;
    } else if (range === 'biWeekly') {
      salaryUnit = "bi weekly";
      startDate = ranges[range].start;
      endDate = ranges[range].end;
    } else if (range === 'thisMonth' || range === 'previousMonth') {
      salaryUnit = "monthly";
      startDate = ranges[range].start;
      endDate = ranges[range].end;
    }

    setPaymentData(prev => ({
      ...prev,
      start_date: startDate,
      end_date: endDate,
      salary_unit: salaryUnit
    }));
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "contact_no") {
      let numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue.length > 14) numericValue = numericValue.slice(0, 14);
      setContactNo(numericValue);
      setFormData((prevData) => ({ ...prevData, [name]: numericValue }));
      setContactNoError("");
    } else if (name === "full_name") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: capitalizeFirstLetter(value),
      }));
      setErrors((prev) => ({ ...prev, full_name: "" }));
    } else if (name === "email") {
      setEmail(value);
      setFormData((prevData) => ({ ...prevData, [name]: value }));
      setEmailError("");
      setErrors((prev) => ({ ...prev, email: "" }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;

    if (name === "salary_amount") {
      const regex = /^\d{0,10}(\.\d{0,2})?$/;

      if (regex.test(value)) {
        setPaymentData((prevData) => ({ ...prevData, [name]: value }));
      }
    } else {
      setPaymentData((prevData) => ({ ...prevData, [name]: value }));
    }
  };



  const handleEdit = async (id, type) => {
    if (type === "payroll") {
      const payroll = payrollData.find((p) => p.id === id);
      if (payroll) {
        setFormData({
          ...initialFormData,
          ...payroll,
        });
        setEmail(payroll.email || "");
        setContactNo(payroll.contact_no || "");
        setEditingPayrollId(id);
        setModalType("edit");
        setShowModal(true);
      }
    } else if (type === "salaryHistory") {
      try {
        const salary = await _Get(`${getAPI("payrollSalaryData")}${id}`);

        if (salary) {
          // Get employee data for selectedPayroll
          const employee = payrollData.find(p => p.id === salary.payroll_employee);
          setSelectedPayroll(employee || { full_name: salary.payroll_employee_name });

          setPaymentData({
            store: storeId,
            payroll_employee: salary.payroll_employee,
            employee_id: salary.employee_id,

            salary_amount: salary.salary_amount,
            salary_unit: salary.salary_unit,
            start_date: salary.start_date,
            end_date: salary.end_date,
            total_hour: salary.total_hour,
            payment_date: salary.payroll_date,

            note: salary.note,
            payment_method: salary.pay_method,
            bank: salary.bank || "",
            bank_name: salary.bank_name || "",
            cheque_no: salary.cheque_no || "",

            allowed_daily_hours: salary.allowed_daily_hours,
            employee_leaves: salary.employee_leaves,
            paid_day_off_leaves: salary.paid_day_off_leaves || 0,
          });

          if (salary) {
            try {
              const response = await GetPaginatedData("preferenceCompanyData");

              const selectedLayout = response.data.find(
                (l) => l.id === salary.cheque_layout
              );

              setSelectedChequeLayout(selectedLayout || null);

            } catch (e) {
              console.error("Error fetching cheque layout:", e);
              setSelectedChequeLayout(null);
            }
          } else {
            setSelectedChequeLayout(null);
          }


          setAllowedDailyHours(salary.allowed_daily_hours || "8");
          setEmployeeLeaves(salary.employee_leaves || "");
          setPaidDayOffLeaves(salary.paid_day_off_leaves || "");

          setTaxDeductionType(salary.tax_deduction_type || "percentage");
          setTaxDeductionValue(
            salary.tax_percentage || salary.tax_amount || ""
          );

          // setWorkingDays(
          //   salary.holidays?.reduce((acc, day) => {
          //     acc[day] = true;
          //     return acc;
          //   }, {}) || {}
          // );

          setWorkingDays({
            ...DEFAULT_WORKING_DAYS,
            ...(salary.holidays || []).reduce((acc, day) => {
              acc[day] = true;
              return acc;
            }, {}),
          });


          setEditingPayrollId(id);
          setModalType("editSalary");
          setShowModal(true);
        } else {
          handleToast({
            type: "ERROR",
            message: "Salary record not found.",
          });
        }
      } catch (error) {
        console.error("Error fetching salary record:", error);
        handleToast({
          type: "ERROR",
          message: `Error fetching salary record: ${error.message}`,
        });
      }
    }
  };



  const togglePaymentModal = async (payroll) => {
    if (!payroll) return;

    setSelectedPayroll(payroll);
    setUseBiometricHours(false);
    setBiometricHoursApplied(false);
    setSelectedBiometricPayrollEmployee(payroll);

    setPaymentData({
      ...initialPaymentData,
      payroll_employee: payroll.id,
      employee_id: payroll.employee_id,
      full_name: payroll.full_name,
    });

    setModalType("payment");
    setShowModal(true);
  };


  const toggleScheduleModal = (payroll) => {
    if (!payroll) {
      console.error("No payroll data provided to toggleScheduleModal");
      return;
    }
    setSelectedPayroll(payroll || null);
    setShowScheduleModal(true);
  };

  const closeScheduleModal = () => {
    setShowScheduleModal(false);
    setSelectedPayroll(null);
  };

  const handlePreviewPayment = () => {
    setShowPreviewModal(true);
  };

  const handleConfirmPayment = () => {
    setShowPreviewModal(false);
    handlePaymentSubmit({ preventDefault: () => { } });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!formData.full_name) {
      newErrors.full_name = "Employee name is required.";
    }

    const contactRegex = /^[0-9]{10}$/;
    if (!contactNo) {
      newErrors.contact_no = "Contact number is required";
    } else if (!contactRegex.test(contactNo)) {
      newErrors.contact_no =
        "Invalid contact number format: must be exactly 10 digits and contain no letters";
    }

    const emailRegex = /^[\w.\-]+\s*@\s*[a-zA-Z][a-zA-Z\d.\-]*\.[a-zA-Z]{2,}$/;
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    setErrors(newErrors);
    setContactNoError(newErrors.contact_no || "");
    setEmailError(newErrors.email || "");

    if (Object.keys(newErrors).length > 0) {
      const firstError = Object.values(newErrors)[0];
      handleToast({
        type: "ERROR",
        message: firstError,
      });
      return;
    }

    const updatedFormData = {
      ...formData,
      email,
      contact_no: contactNo,
      store: storeId,
    };

    try {
      let response;

      if (editingPayrollId) {
        response = await Patch(
          "payrollEmployeeData",
          editingPayrollId,
          updatedFormData
        );

        if (response.status === 200) {
          setPayrollData((prevData) =>
            prevData.map((payroll) =>
              payroll.id === editingPayrollId
                ? { ...payroll, ...updatedFormData }
                : payroll
            )
          );

          handleToast({
            type: "SUCCESS",
            message: "Payroll updated successfully!",
          });
          await fetchPayrollData({ page: currentPage, searchTerm });
        }
      } else {
        response = await Post("payrollEmployeeData", updatedFormData);

        if (response.status === 201) {
          setPayrollData((prevData) => [...prevData, response.data]);

          handleToast({
            type: "SUCCESS",
            message: "Payroll added successfully!",
          });
          await fetchPayrollData({ page: currentPage, searchTerm });
        } else if (response.data) {
          const errorMessages = Object.entries(response.data)
            .map(([field, messages]) => `${messages.join(", ")}`)
            .join("\n");

          handleToast({
            type: "ERROR",
            message: `${errorMessages || "An unknown error occurred"}`,
          });
          return;
        } else {
          handleToast({
            type: "ERROR",
            message: "Please Validate Fields!",
          });
          return;
        }
      }

      closeModal();
    } catch (error) {
      console.error("Error submitting form", error);
      if (error.response?.data) {
        const errorMessages = Object.entries(error.response.data)
          .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
          .join("\n");

        handleToast({
          type: "ERROR",
          message: `${errorMessages || "An unknown error occurred"}`,
        });
      } else {
        handleToast({
          type: "ERROR",
          message: `${error.message || "An unknown error occurred"}`,
        });
      }
    }
  };




  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    if (!paymentData.salary_amount) {
      handleToast({
        type: "ERROR",
        message: "Payment amount is required",
      });
      return;
    }

    if (paymentData.payment_method === "cheque" && !paymentData.bank) {
      handleToast({
        type: "ERROR",
        message: "Please select a bank when paying by cheque.",
      });
      return;
    }

    const selectedBank = bankdata.find((b) => b.id === paymentData.bank);
    const bankName = selectedBank ? selectedBank.name : null;

    try {
      setLoading(true);
      const preview = calculatePreview();
      const payload = {
        store: storeId,

        payroll_employee: selectedPayroll?.id,
        employee_id: selectedPayroll?.employee_id,

        payroll_date: paymentData.payment_date,
        salary_unit: paymentData.salary_unit,
        start_date: paymentData.start_date,
        end_date: paymentData.end_date,

        salary_amount: paymentData.salary_amount,
        total_hour: paymentData.total_hour || 0,
        // total_amount: preview.grossSalary,
        total_amount: preview.netSalary,
        cheque_layout: selectedChequeLayout?.id || null,

        //  TAX
        tax_deduction_type: taxDeductionType,
        tax_percentage:
          taxDeductionType === "percentage" ? taxDeductionValue : null,
        tax_amount: preview.deduction,

        // HOURS / LEAVES
        allowed_daily_hours: allowedDailyHours || 0,
        employee_leaves: employeeLeaves || 0,
        paid_day_off_leaves: paidDayOffLeaves || 0,

        // CALCULATED RATES
        calculated_daily_rate: (() => {
          if (paymentData.salary_unit === "hourly") return null;

          const amount = parseFloat(paymentData.salary_amount) || 0;
          const startDate = new Date(paymentData.start_date);
          const endDate = new Date(paymentData.end_date);
          const daysDiff =
            Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

          const holidaysCount = Object.values(workingDays).filter(Boolean).length;
          const workingDaysPerWeek = Math.max(0, 7 - holidaysCount);
          const weeks = Math.floor(daysDiff / 7);
          const remainingDays = daysDiff % 7;

          const totalWorkingDays =
            weeks * workingDaysPerWeek +
            Math.min(remainingDays, workingDaysPerWeek);

          const leaves = parseInt(employeeLeaves) || 0;
          const paidLeaves = parseInt(paidDayOffLeaves) || 0;
          const adjustedWorkingDays = Math.max(
            0,
            totalWorkingDays - leaves + paidLeaves
          );

          return adjustedWorkingDays > 0
            ? (amount / adjustedWorkingDays).toFixed(2)
            : null;
        })(),

        calculated_hourly_rate:
          paymentData.salary_unit === "hourly"
            ? paymentData.salary_amount
            : null,

        // BI-WEEKLY
        amount_per_bi_week:
          paymentData.salary_unit === "bi weekly"
            ? preview.grossSalary
            : null,

        //  HOLIDAYS
        holidays: Object.keys(workingDays).filter(
          (day) => workingDays[day]
        ),

        pay_method: paymentData.payment_method,
        bank: paymentData.payment_method === "cheque" ? paymentData.bank : "",
        bank_name: bankName,
        cheque_no:
          paymentData.payment_method === "cheque"
            ? paymentData.cheque_no || ""
            : null,

        note: paymentData.note,
        is_bio: useBiometricHours,
        face_profile_id: faceProfileId,
      };

      //  create an dupdate payroll salary record
      if (editingPayrollId) {
        await Patch("payrollSalaryData", editingPayrollId, payload);
      } else {
        await Post("payrollSalaryData", payload);
      }

      //  create chque record if paymnet method is cheque 
      if (paymentData.payment_method === "cheque") {
        const chequePayload = {
          store: storeId,
          cheque_no: paymentData.cheque_no,
          name: selectedPayroll?.full_name,
          amount: preview.netSalary,
          created_by: user.user_id,
        };

        await Post("chequeData", chequePayload);
      }

      handleToast({
        type: "SUCCESS",
        message: editingPayrollId
          ? "Payment updated successfully!"
          : "Payment processed successfully!",
      });

      setSalaryHistoryRefreshKey((prev) => prev + 1);
      closeModal();

    } catch (error) {
      console.error("Error processing payment:", error);

      let message = "Payment failed";
      if (error.response?.data) {
        const data = error.response.data;
        if (typeof data === "object" && !Array.isArray(data)) {
          const errorMessages = Object.entries(data)
            .map(([field, messages]) => {
              if (field === "store_info" || typeof messages === "object" && !Array.isArray(messages)) {
                return null;
              }
              if (Array.isArray(messages)) {
                return messages.join(", ");
              }
              return String(messages);
            })
            .filter(Boolean)
            .join(". ");
          
          message = errorMessages || "Payment failed";
        } else if (data.message) {
          message = data.message;
        } else if (typeof data === "string") {
          message = data;
        }
      } else if (error.message) {
        message = error.message;
      }

      handleToast({
        type: "ERROR",
        message,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, type) => {
    const result = await confirmDelete();

    if (!result.isConfirmed) return;

    try {
      if (type === "payroll") {
        await Delete(`payrollEmployeeData`, id);

        setPayrollData((prevPayrollData) =>
          prevPayrollData.filter((p) => p.id !== id)
        );

        const updatedSalaryHistory = await Get("payrollSalaryData");
        setSalaryHistory(updatedSalaryHistory);

        handleToast({
          type: "SUCCESS",
          message: "Payroll record deleted successfully!",
        });
      } else if (type === "salaryHistory") {
        await Delete(`payrollSalaryData`, id);

        handleToast({
          type: "SUCCESS",
          message: "Salary history record deleted successfully",
        });

        setSalaryHistoryRefreshKey((prev) => prev + 1);
      }
    } catch (error) {
      console.error("Error deleting record:", error);

      handleToast({
        type: "ERROR",
        message: `Error processing payment: ${error.response?.data?.message || error.message
          }`,
      });
    }
  };

  const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
  const handleEmailBlur = () => {
    if (!email) {
      setEmailError("Email is required");
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleEmailFocus = () => {
    setEmailError("");
  };

  const handleContactNoBlur = () => {
    const contactRegex = /^[0-9]{10}$/;
    if (!contactNo) {
      setContactNoError("Contact number is required");
    } else if (!contactRegex.test(contactNo)) {
      setContactNoError(
        "Invalid contact number format: must be exactly 10 digits and contain no letters"
      );
    } else {
      setContactNoError("");
    }
  };

  const handleContactNoFocus = () => {
    setContactNoError("");
  };

  useEffect(() => {
    if (showModal && modalType === "payment" && selectedPayroll) {
      setSelectedBiometricPayrollEmployee(selectedPayroll);
    }
  }, [showModal, modalType, selectedPayroll]);

  useEffect(() => {
    if (!useBiometricHours) return;
    if (!biometricCalculatedHours || biometricCalculatedHours.total === undefined) return;

    setPaymentData((prev) => ({
      ...prev,
      total_hour: Number(biometricCalculatedHours.total.toFixed(2)).toString(),
    }));
    setBiometricHoursApplied(true);
  }, [biometricCalculatedHours, useBiometricHours]);

  const biometricFormatTime = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = String(timeStr).split(":");
    return `${String(hours || "00").padStart(2, "0")}:${String(minutes || "00").padStart(2, "0")}`;
  };

  const biometricConvertHoursToHMS = (decimalHours) => {
    const totalSeconds = Math.floor((parseFloat(decimalHours) || 0) * 3600);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h : ${minutes}min : ${seconds}sec`;
  };

  const validateBiometricPullCriteria = () => {
    if (!selectedPayroll) {
      handleToast({
        type: "ERROR",
        message: "Please select employee first.",
      });
      return false;
    }

    if (!selectedPayroll.employee_id) {
      handleToast({
        type: "ERROR",
        message: "This employee does not have biometric employee id mapped.",
      });
      return false;
    }

    if (!paymentData.start_date || !paymentData.end_date) {
      handleToast({
        type: "ERROR",
        message: "Please select start date and end date first.",
      });
      return false;
    }

    if (!allowedDailyHours) {
      handleToast({
        type: "ERROR",
        message: "Please enter allowed daily hours first.",
      });
      return false;
    }

    return true;
  };

  const fetchBiometricHoursAndApply = async () => {
    if (!validateBiometricPullCriteria()) return;

    try {
      setBiometricLoading(true);
      setBiometricHoursApplied(false);
      setSelectedBiometricPayrollEmployee(selectedPayroll);

      const response = await Post("faceTotalWorkedHours", {
        employee_id: selectedPayroll.employee_id,
        start_date: paymentData.start_date,
        end_date: paymentData.end_date,
        working_hours_per_day: parseFloat(allowedDailyHours),
      });

      const data = response?.data || {};
      const totalHours =
        typeof data.total_hours === "number"
          ? data.total_hours
          : parseFloat(data.total_hours || 0) || 0;
      const dailyLogs = Array.isArray(data.results) ? data.results : [];

      const totalMinutes = Math.round(totalHours * 60);
      const hoursPerWeek = (parseFloat(allowedDailyHours) || 0) * 5;
      const hoursPerMonth = hoursPerWeek * 4;
      const weeklyFraction = hoursPerWeek ? totalHours / hoursPerWeek : 0;
      const monthlyFraction = hoursPerMonth ? totalHours / hoursPerMonth : 0;

      setBiometricDailyLog(dailyLogs);
      setBiometricCalculatedHours({
        total: totalHours,
        totalMinutes,
        weeklyFraction,
        monthlyFraction,
        weeklyPercent: weeklyFraction * 100,
        monthlyPercent: monthlyFraction * 100,
      });

      setPaymentData((prev) => ({
        ...prev,
        total_hour: Number(totalHours.toFixed(2)).toString(),
      }));
      setBiometricHoursApplied(true);

      handleToast({
        type: "SUCCESS",
        message: "Biometric hours applied to payable hours.",
      });
    } catch (error) {
      console.error("Error pulling biometric hours:", error);
      setBiometricDailyLog([]);
      setBiometricCalculatedHours(null);
      setBiometricHoursApplied(false);
      handleToast({
        type: "ERROR",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to pull biometric hours.",
      });
    } finally {
      setBiometricLoading(false);
    }
  };

  const handleToggleBiometricHours = () => {
    if (useBiometricHours) {
      setUseBiometricHours(false);
      setBiometricHoursApplied(false);
      setBiometricCalculatedHours(null);
      setBiometricDailyLog([]);
      setPaymentData((prev) => ({
        ...prev,
        total_hour: calculateWorkedHours().toString(),
      }));
      return;
    }

    setUseBiometricHours(true);
    fetchBiometricHoursAndApply();
  };

  const handleRefreshBiometricHours = () => {
    setUseBiometricHours(true);
    fetchBiometricHoursAndApply();
  };

  const renderBiometricHoursPullPanel = () => (
    <div
      className="mx-3 mb-4"
      style={{
        background: useBiometricHours
          ? "linear-gradient(135deg, #ecfdf3, #eff6ff)"
          : "#f8f9fa",
        border: useBiometricHours
          ? "1px solid rgba(34, 197, 94, 0.45)"
          : "1px solid #e5e7eb",
        borderRadius: "14px",
        padding: "14px 16px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <div style={{ fontSize: "15px", fontWeight: 800, color: "#111827" }}>
            Pull Actual Hours From Biometric
          </div>
          <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "3px" }}>
            Keep manual payroll options like holidays, salary unit, tax, cash/cheque and use biometric attendance only for payable hours.
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <button
            type="button"
            onClick={handleToggleBiometricHours}
            style={{
              border: "none",
              borderRadius: "999px",
              padding: "10px 16px",
              cursor: "pointer",
              fontWeight: 800,
              color: useBiometricHours ? "#ffffff" : "#111827",
              background: useBiometricHours
                ? "linear-gradient(135deg, #15803d, #22c55e)"
                : "#ffffff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            {useBiometricHours ? "Biometric ON" : "Use Biometric Hours"}
          </button>

          {useBiometricHours && (
            <button
              type="button"
              onClick={handleRefreshBiometricHours}
              style={{
                border: "1px solid #16a34a",
                borderRadius: "999px",
                padding: "10px 16px",
                cursor: "pointer",
                fontWeight: 700,
                color: "#166534",
                background: "#ffffff",
              }}
            >
              Refresh Hours
            </button>
          )}
        </div>
      </div>

      {useBiometricHours && (
        <div
          style={{
            marginTop: "12px",
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: "10px",
          }}
        >
          <div style={{ background: "#ffffff", borderRadius: "12px", padding: "10px", border: "1px solid #dcfce7" }}>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>Employee</div>
            <div style={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
              {selectedPayroll?.full_name || selectedBiometricPayrollEmployee?.full_name || "-"}
            </div>
          </div>

          <div style={{ background: "#ffffff", borderRadius: "12px", padding: "10px", border: "1px solid #dcfce7" }}>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>Date Range</div>
            <div style={{ fontSize: "13px", fontWeight: 700, color: "#111827" }}>
              {paymentData.start_date || "-"} to {paymentData.end_date || "-"}
            </div>
          </div>

          <div style={{ background: "#ffffff", borderRadius: "12px", padding: "10px", border: "1px solid #dcfce7" }}>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>Biometric Hours</div>
            <div style={{ fontSize: "13px", fontWeight: 800, color: "#15803d" }}>
              {biometricLoading
                ? "Calculating..."
                : biometricCalculatedHours?.total !== undefined
                  ? `${biometricCalculatedHours.total.toFixed(2)}h`
                  : "Waiting"}
            </div>
          </div>

          <div style={{ background: "#ffffff", borderRadius: "12px", padding: "10px", border: "1px solid #dcfce7" }}>
            <div style={{ fontSize: "11px", color: "#6b7280" }}>Status</div>
            <div style={{ fontSize: "13px", fontWeight: 800, color: biometricHoursApplied ? "#15803d" : "#92400e" }}>
              {biometricHoursApplied ? "Applied to payable hours" : "Ready to apply"}
            </div>
          </div>
        </div>
      )}

      {useBiometricHours && biometricDailyLog.length > 0 && (
        <div className="daily-log" style={{ marginTop: "14px", maxHeight: "220px", overflow: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Day</th>
                <th>In</th>
                <th>Out</th>
                <th>Hours</th>
              </tr>
            </thead>
            <tbody>
              {biometricDailyLog.map((log, index) => (
                <tr key={`${log.date}-${index}`}>
                  <td>{log.date}</td>
                  <td>{log.day}</td>
                  <td>{biometricFormatTime(log.clock_in_time)}</td>
                  <td>{biometricFormatTime(log.clock_out_time)}</td>
                  <td>{biometricConvertHoursToHMS(log.hours_worked)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );

  return (
    <>
      <ToastContainer />
      <div className="responsive-box">
        <div className="p-2">
          <div className="">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="mb-1">Manage Employee</h3>
              {/* <CustomButton
                text=" + Add Employee"
                icon={employeeIcon}
                onClick={() => {
                  setModalType("new");
                  setShowModal(true);
                }}
                color="#000000"
                backgroundColor="#FFAF32"
                iconPosition="right"
              /> */}
            </div>

            <PayrollTableWithButton
              data={formattedPayrollData}
              columns={[
                { header: "Name", field: "full_name" },
                { header: "Phone", field: "contact_no" },
                { header: "Email", field: "email" },
                { header: "Date", field: "date" },
                { header: "Pay Salary", field: "pay_salary" },

              ]}
              showAction={false}
           
              onEdit={(id) => handleEdit(id, "payroll")}
              onDelete={(id) => handleDelete(id, "payroll")}
              togglePaymentModal={togglePaymentModal}
              toggleScheduleModal={toggleScheduleModal}
              showFooter={true}
              loading={loading}
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              onSearch={handleSearch}
            />
          </div>
          { }
          <ReusableModal
            show={showModal}
            handleClose={handleModalClose}
            title={
              modalType === "new"
                ? "Add Employee"
                : modalType === "edit"
                  ? "Edit Employee"
                  : modalType === "payment"
                    ? `Pay Salary For ${selectedPayroll?.full_name || ""}`

                    : modalType === "editSalary"
                      ? "edit salary"
                      : ""
            }
            width="1000px"
          >
            {(modalType === "new" || modalType === "edit") && (
              <form onSubmit={handleSubmit}>
                <div
                  className="d-flex flex-column"
                  style={{
                    marginLeft: "20px",
                    marginRight: "10px",
                    marginTop: "20px",
                  }}
                ></div>

                <div className="d-flex align-items-center mb-4 mx-3">
                  <ReusableInput
                    type="text"
                    name="full_name"
                    label="Employee Name"
                    placeholder=""
                    required
                    value={formData.full_name}
                    onChange={(e) => {
                      const onlyLetters = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        ""
                      );
                      const capitalized = capitalizeFirstLetter(onlyLetters);
                      handleFullNameChange({
                        target: { name: "full_name", value: capitalized },
                      });
                    }}
                    error={errors.full_name}
                  />
                </div>

                { }

                <div className="d-flex align-items-center mb-4 mx-3">
                  <ReusableInput
                    type="tel"
                    name="contact_no"
                    label="Contact Number"
                    placeholder=""
                    required
                    value={formData.contact_no}
                    onChange={handleContactNoChange}
                    onBlur={handleContactNoBlur}
                    onFocus={handleContactNoFocus}
                    maxLength={14}
                    error={errors.contact_no}
                  />
                </div>

                <div className="d-flex align-items-center mb-4 mx-3">
                  <ReusableInput
                    type="email"
                    name="email"
                    label="Email"
                    placeholder=""
                    required
                    value={formData.email}
                    onChange={handleEmailChange}
                    onBlur={handleEmailBlur}
                    onFocus={handleEmailFocus}
                    error={errors.email}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginRight: "10px",
                    marginBottom: "20px",
                    gap: "20px",
                  }}
                >
                  {modalType !== "edit" && (
                    <RegularButton
                      text="Clear"
                      onClick={clearForm}
                      backgroundColor="#ffffff"
                      color="#282E26"
                    />
                  )}
                  <RegularButton
                    type="submit"
                    text={modalType === "edit" ? "Update " : "Save"}
                    backgroundColor="#282E26"
                  />
                </div>
              </form>
            )}
            {(modalType === "payment" || modalType === "editSalary") && (
              <>
                {modalType === "payment" && renderBiometricHoursPullPanel()}

              <form onSubmit={handlePaymentSubmit}>
                <div className="modal-body">
                  <div className="row mb-4 mx-3">
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">Start Date *</label>
                        <input
                          type="date"
                          className="form-control"
                          id="start-date-input"
                          name="start_date"
                          value={paymentData.start_date}
                          onChange={handlePaymentChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-3">
                        <label className="form-label">End Date *</label>
                        <input
                          type="date"
                          className="form-control"
                          id="end-date-input"
                          name="end_date"
                          value={paymentData.end_date}
                          onChange={handlePaymentChange}
                          required
                        />
                      </div>
                    </div>
                  </div>


                  {/* Date Range Buttons */}
                  <div className="d-flex justify-content-center mb-4 mx-3">
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                      <button
                        type="button"
                        id="hourly-button"
                        onClick={() => setDateRange('hourly')}
                        style={{
                          backgroundColor: selectedDateRange === 'hourly' ? "#282E26" : "#f8f9fa",
                          color: selectedDateRange === 'hourly' ? "#ffffff" : "#000000",
                          border: "1px solid #dee2e6",
                          borderRadius: "5px",
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: "14px"
                        }}
                      >
                        Hourly
                      </button>
                      <button
                        type="button"
                        id="current-week-button"
                        onClick={() => setDateRange('currentWeek')}
                        style={{
                          backgroundColor: selectedDateRange === 'currentWeek' ? "#282E26" : "#f8f9fa",
                          color: selectedDateRange === 'currentWeek' ? "#ffffff" : "#000000",
                          border: "1px solid #dee2e6",
                          borderRadius: "5px",
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: "14px"
                        }}
                      >
                        Current Week
                      </button>
                      <button
                        type="button"
                        id="biweekly-button"
                        onClick={() => setDateRange('biWeekly')}
                        style={{
                          backgroundColor: selectedDateRange === 'biWeekly' ? "#282E26" : "#f8f9fa",
                          color: selectedDateRange === 'biWeekly' ? "#ffffff" : "#000000",
                          border: "1px solid #dee2e6",
                          borderRadius: "5px",
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: "14px"
                        }}
                      >
                        Bi Weekly
                      </button>
                      <button
                        type="button"
                        onClick={() => setDateRange('thisMonth')}
                        style={{
                          backgroundColor: selectedDateRange === 'thisMonth' ? "#282E26" : "#f8f9fa",
                          color: selectedDateRange === 'thisMonth' ? "#ffffff" : "#000000",
                          border: "1px solid #dee2e6",
                          borderRadius: "5px",
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: "14px"
                        }}
                      >
                        This Month
                      </button>
                      <button
                        type="button"
                        onClick={() => setDateRange('previousMonth')}
                        style={{
                          backgroundColor: selectedDateRange === 'previousMonth' ? "#282E26" : "#f8f9fa",
                          color: selectedDateRange === 'previousMonth' ? "#ffffff" : "#000000",
                          border: "1px solid #dee2e6",
                          borderRadius: "5px",
                          padding: "8px 16px",
                          cursor: "pointer",
                          fontSize: "14px"
                        }}
                      >
                        Previous Month
                      </button>
                    </div>
                  </div>


                  {/* Holidays Checkboxes - Hide for hourly */}
                  {paymentData.salary_unit !== "hourly" && (

                    <div className="mb-4 mx-3">
                      <label style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        marginBottom: "12px",
                        display: "block",
                        color: "#333"
                      }}>Holidays (Select days that are holidays)</label>
                      <div style={{
                        display: "flex",
                        gap: "20px",
                        flexWrap: "wrap",
                        padding: "12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef"
                      }}>
                        {Object.entries(workingDays).map(([day, checked]) => (
                          <label key={day} style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            backgroundColor: checked ? "#ffebee" : "transparent",
                            transition: "background-color 0.2s"
                          }}>
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={(e) => {
                                setWorkingDays(prev => ({
                                  ...prev,
                                  [day]: e.target.checked
                                }));
                              }}
                              style={{
                                marginRight: "8px",
                                transform: "scale(1.1)"
                              }}
                            />
                            <span style={{
                              fontSize: "14px",
                              fontWeight: checked ? "500" : "400",
                              color: checked ? "#d32f2f" : "#666"
                            }}>{day}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Hours Summary */}
                  <div className="row mb-4 mx-3">
                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">Hours Summary</label>
                      </div>
                      <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                        gap: "14px",
                        alignItems: "stretch",
                        padding: "15px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef"
                      }}>
                        <div style={{
                          backgroundColor: "#f3e5f5",
                          color: "#7b1fa2",
                          padding: "12px 18px",
                          borderRadius: "18px",
                          fontSize: "15px",
                          fontWeight: "700",
                          border: "2px solid #e1bee7",
                          textAlign: "center"
                        }}>
                          Expected Hours
                          <div style={{ fontSize: "20px", marginTop: "4px" }}>
                            {calculateExpectedHours()}h
                          </div>
                        </div>

                        <div style={{
                          backgroundColor: useBiometricHours ? "#ecfdf3" : "#e3f2fd",
                          color: useBiometricHours ? "#166534" : "#1976d2",
                          padding: "12px 18px",
                          borderRadius: "18px",
                          fontSize: "15px",
                          fontWeight: "700",
                          border: useBiometricHours ? "2px solid #bbf7d0" : "2px solid #bbdefb",
                          textAlign: "center"
                        }}>
                          {useBiometricHours ? "Biometric Actual Hours" : "Manual Worked Hours"}
                          <div style={{ fontSize: "20px", marginTop: "4px" }}>
                            {useBiometricHours && biometricCalculatedHours?.total !== undefined
                              ? `${biometricCalculatedHours.total.toFixed(2)}h`
                              : `${calculateWorkedHours()}h`}
                          </div>
                        </div>

                        <div style={{
                          backgroundColor: "#ffffff",
                          color: "#111827",
                          padding: "12px 18px",
                          borderRadius: "18px",
                          fontSize: "14px",
                          fontWeight: "700",
                          border: "2px solid #e5e7eb",
                        }}>
                          <label className="form-label" style={{ marginBottom: "6px" }}>
                            Payable Hours
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="total_hour"
                            value={paymentData.total_hour}
                            onChange={(e) => {
                              let value = e.target.value.replace(/[^0-9.]/g, "");
                              if (value.indexOf(".") !== -1) {
                                const parts = value.split(".");
                                value = parts[0] + "." + parts[1].substring(0, 2);
                              }
                              setPaymentData((prev) => ({
                                ...prev,
                                total_hour: value,
                              }));
                            }}
                            placeholder="Enter payable hours"
                          />
                          <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "5px" }}>
                            You can modify this manually even after pulling biometric hours.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4 mx-3">
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Salary Unit *</label>
                        <select
                          className="form-select"
                          name="salary_unit"
                          id="salary-unit-select"
                          value={paymentData.salary_unit}
                          onChange={handlePaymentChange}
                          required
                          // disabled={selectedDateRange !== null}
                          style={selectedDateRange !== null ? { backgroundColor: "#f8f9fa" } : {}}
                        >
                          <option value="hourly">Hourly</option>
                          <option value="weekly">Weekly</option>
                          <option value="bi weekly">Bi Weekly</option>
                          <option value="monthly">Monthly</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">
                          {paymentData.salary_unit === "hourly" ? "Amount Per Hour *" :
                            paymentData.salary_unit === "weekly" ? "Amount Per Week *" :
                              paymentData.salary_unit === "bi weekly" ? "Amount Per Bi-Week *" :
                                "Amount Per Month *"}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          // id="salary_amount"
                          id="salary-amount-input"
                          name="salary_amount"
                          value={paymentData.salary_amount}
                          onChange={handlePaymentChange}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                          required
                          onInput={(e) => {
                            let value = e.target.value;
                            value = value.replace(/[^0-9.]/g, "");
                            if (value.indexOf(".") !== -1) {
                              const parts = value.split(".");
                              value = parts[0] + "." + parts[1].substring(0, 2);
                            }
                            e.target.value = value;
                            handlePaymentChange(e);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Payment Date *</label>
                        <input
                          type="date"
                          className="form-control"
                          id="payment-date-input"
                          name="payment_date"
                          value={paymentData.payment_date}
                          onChange={handlePaymentChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">{taxDeductionType === "percentage" ? "Tax Percentage (%)" : "Tax Amount"}</label>
                        <input
                          type="text"
                          className="form-control"
                           id="tax-input"
                          value={taxDeductionValue}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9.]/g, "");
                            if (value.indexOf(".") !== -1) {
                              const parts = value.split(".");
                              value = parts[0] + "." + parts[1].substring(0, 2);
                            }
                            setTaxDeductionValue(value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4 mx-3">

                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Calculated Hourly Rate</label>
                        <input
                          type="text"
                          className="form-control"
                          value={paymentData.salary_amount && allowedDailyHours && paymentData.start_date && paymentData.end_date ? (() => {
                            const amount = parseFloat(paymentData.salary_amount);
                            const dailyHours = parseFloat(allowedDailyHours) || 8;
                            const startDate = new Date(paymentData.start_date);
                            const endDate = new Date(paymentData.end_date);
                            const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
                            const holidaysCount = Object.values(workingDays).filter(day => day).length;
                            const workingDaysPerWeek = 7 - holidaysCount;
                            const totalWorkingDays = Math.floor(daysDiff / 7) * workingDaysPerWeek;
                            const totalHours = totalWorkingDays * dailyHours;
                            return totalHours > 0 ? Math.floor((amount / totalHours) * 100) / 100 : "0.00";
                          })() : "0.00"}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Calculated Daily Rate</label>
                        <input
                          type="text"
                          className="form-control"
                          value={paymentData.salary_amount && paymentData.start_date && paymentData.end_date ? (() => {
                            const amount = parseFloat(paymentData.salary_amount);
                            const startDate = new Date(paymentData.start_date);
                            const endDate = new Date(paymentData.end_date);
                            const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
                            const holidaysCount = Object.values(workingDays).filter(day => day).length;
                            const workingDaysPerWeek = Math.max(0, 7 - holidaysCount);
                            const weeks = Math.floor(daysDiff / 7);
                            const remainingDays = daysDiff % 7;
                            const totalWorkingDays = (weeks * workingDaysPerWeek) + Math.min(remainingDays, workingDaysPerWeek);
                            const leaves = parseInt(employeeLeaves) || 0;
                            const paidLeaves = parseInt(paidDayOffLeaves) || 0;
                            const adjustedWorkingDays = Math.max(0, totalWorkingDays - leaves + paidLeaves);
                            return adjustedWorkingDays > 0 ? (amount / adjustedWorkingDays).toFixed(6) : "0.000000";
                          })() : "0.000000"}
                          readOnly
                          style={{ backgroundColor: "#f8f9fa" }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Employee Leaves</label>
                        <input
                          type="text"
                          className="form-control"
                          id="employee-leaves-input"
                          value={employeeLeaves}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            setEmployeeLeaves(value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Tax Deduction Type</label>
                        <select
                          className="form-select"
                          name="tax_deduction_type"
                          value={taxDeductionType}
                          onChange={(e) => setTaxDeductionType(e.target.value)}
                        >
                          <option value="percentage">Percentage</option>
                          <option value="amount">Amount</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4 mx-3">

                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Allowed Daily Hours</label>
                        <input
                          type="text"
                          className="form-control"
                          id="allowed-daily-hours-input"
                          value={allowedDailyHours}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            setAllowedDailyHours(value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-3">
                      <div className="mb-3">
                        <label className="form-label">Paid Day Off Leaves</label>
                        <input
                          type="text"
                          className="form-control"
                          id="paid-day-off-leaves-input"
                          value={paidDayOffLeaves}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^0-9]/g, "");
                            setPaidDayOffLeaves(value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>




                  <div className="row mb-4 mx-3">

                    <div className="col-3 d-flex align-items-end justify-content-center">
                      <div
                        style={{
                          border: "1px solid #ACB4AA",
                          borderRadius: "40px",
                          display: "flex",
                          padding: "5px",

                        }}
                      >
                        <button
                          type="button"
                          id="payment-method-cash-button"
                          onClick={() =>
                            handlePaymentChange({
                              target: { name: "payment_method", value: "cash" },
                            })
                          }
                          style={{
                            backgroundColor:
                              paymentData.payment_method === "cash"
                                ? "#4a5546"
                                : "transparent",
                            color:
                              paymentData.payment_method === "cash"
                                ? "#ffffff"
                                : "#000000",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "20px",
                            cursor: "pointer",
                            fontWeight: "bold",
                          }}
                        >
                          Cash
                        </button>
                        <button
                          type="button"
                          id="payment-method-cheque-button"
                          onClick={() =>
                            handlePaymentChange({
                              target: {
                                name: "payment_method",
                                value: "cheque",
                              },
                            })
                          }
                          style={{
                            backgroundColor:
                              paymentData.payment_method === "cheque"
                                ? "#4a5546"
                                : "transparent",
                            color:
                              paymentData.payment_method === "cheque"
                                ? "#ffffff"
                                : "#000000",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "20px",
                            cursor: "pointer",
                            fontWeight: "bold",
                          }}
                        >
                          Cheque
                        </button>
                      </div>
                    </div>
                  </div>
                  {paymentData.payment_method === "cheque" && (
                    <div className="row mb-4 mx-3">

                      {/* Bank */}
                      <div className="col-3">
                        <div className="mb-3">
                          <label className="form-label">Bank *</label>
                          <select
                            className="form-select"
                            id="bank-select"
                            name="bank"
                            value={paymentData.bank}
                            onChange={handlePaymentChange}
                            required
                          >
                            <option value="">Select Bank</option>
                            {bankdata.map((bank) => (
                              <option key={bank.id} value={bank.id}>
                                {bank.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Cheque No */}
                      <div className="col-3">
                        <div className="mb-3">
                          <label className="form-label">Cheque No *</label>
                          <input
                            type="number"
                            className="form-control"
                            id="cheque-no-input"
                            name="cheque_no"
                            value={paymentData.cheque_no}
                            onChange={handlePaymentChange}
                            required
                          />
                        </div>
                      </div>

                      {/* Cheque Layout */}
                      <div className="col-3">
                        <div className="mb-3" style={{marginTop:'20px'}}>
                          {/* <label className="form-label">Cheque Layout *</label> */}

                          <PaginatedSearchSelect
                            api="preferenceCompanyData"
                            GetPaginatedData={GetPaginatedData}
                            placeholder="Select Cheque Layout"
                            value={selectedChequeLayout}
                            getOptionLabel={(opt) => opt.layout_name}
                            onSelect={(opt) => {
                              setSelectedChequeLayout(opt);
                            }}
                          />
                        </div>
                      </div>
                      {/*  chque preview  */}
                      {selectedChequeLayout && (
                        <div className="row mt-4 mx-3">
                          <div className="col-12">
                            <h6 style={{ marginBottom: "10px" }} id="cheque-preview-heading">Cheque Preview</h6>

                            <div style={{
                              background: "#f8f9fa",
                              padding: "15px",
                              borderRadius: "8px",
                              overflowX: "auto"
                            }}>
                              <ChequeRenderer
                                layout={selectedChequeLayout}
                                chequeData={chequePreviewData}
                                logo={user.logo}
                                signature={user.digital_signature}
                                showPrint
                              />
                            </div>
                          </div>
                        </div>
                      )}

                    </div>
                  )}

                </div>
                <div className="modal-footer" style={{ border: "none" }}>
                  {modalType !== "editSalary" && (
                    <RegularButton
                      text="Clear"
                      id="clear-payment-button"
                      onClick={clearPaymentForm}
                      backgroundColor="#ffffff"
                      color="#282E26"
                    />
                  )}

                  <RegularButton
                    type="button"
                    id={modalType === "editSalary" ? "update-payment-button" : "preview-pay-button"}
                    text={modalType === "editSalary" ? "Update" : "Preview Pay"}
                    backgroundColor="#282E26"
                    onClick={modalType === "editSalary" ? handlePaymentSubmit : handlePreviewPayment}
                  />
                </div>
              </form>
              </>
            )}


          </ReusableModal>

          {/* Preview Modal */}
          <ReusableModal
            show={showPreviewModal}
            handleClose={() => setShowPreviewModal(false)}
            title={`Payment Preview - ${selectedPayroll?.full_name || ""}`}
            id="payment-preview-heading"
            width="500px"
          >
            <div className="p-4" style={{ fontSize: "14px", color: "#222" }}>

              <div className="mb-2">
                <h5 style={{ fontSize: "15px", fontWeight: 600 }}>Calculation Summary</h5>
                <hr style={{ borderTop: "1px solid #ddd", margin: "8px 0" }} />
              </div>

              {(() => {
                const preview = calculatePreview();
                return (
                  <div>

                    {/* HOURLY */}
                    {preview.unit === "hourly" ? (
                      <>
                        <div className="row mb-1">
                          <div className="col-6" style={{ color: "#555" }}>Total Hours</div>
                          <div className="col-6 text-end">{preview.totalHours}</div>
                        </div>

                        <div className="row mb-1">
                          <div className="col-6" style={{ color: "#555" }}>Hourly Rate</div>
                          <div className="col-6 text-end">{preview.hourlyRate}</div>
                        </div>

                        <div className="row mb-2">
                          <div className="col-12" style={{ fontSize: "13px", color: "#444" }}>
                            <strong>Calculation:</strong> {preview.calculation}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {[
                          ["Date Range", preview.dateRange],
                          ["Total Days", preview.totalDays],
                          ["Holidays / Week", preview.holidaysPerWeek],
                          ["Working Days / Week", preview.workingDaysPerWeek],
                          ["Total Working Days", preview.totalWorkingDays],
                          ["Employee Leaves", preview.employeeLeaves],
                          ["Paid Leaves", preview.paidLeaves],
                          ["Adjusted Working Days", preview.adjustedWorkingDays],
                          ["Daily Hours", preview.dailyHours],
                          ["Total Hours", preview.totalHours],
                          ["Daily Rate", preview.dailyRate],
                        ].map(([label, value], i) => (
                          <div className="row mb-1" key={i}>
                            <div className="col-6" style={{ color: "#555" }}>{label}</div>
                            <div className="col-6 text-end">{value}</div>
                          </div>
                        ))}

                        <div className="row mb-2">
                          <div className="col-12" style={{ fontSize: "13px", color: "#444" }}>
                            <strong>Calculation:</strong> {preview.calculation}
                          </div>
                        </div>
                      </>
                    )}

                    <hr style={{ borderTop: "1px solid #ddd", margin: "8px 0" }} />

                    <div className="row mb-1">
                      <div className="col-6" style={{ fontWeight: 600 }}>Gross Salary</div>
                      <div className="col-6 text-end">{preview.grossSalary}</div>
                    </div>

                    {preview.taxValue && (
                      <div className="row mb-1">
                        <div className="col-6" style={{ color: "#b00020" }}>
                          Tax ({preview.taxType})
                        </div>
                        <div className="col-6 text-end" style={{ color: "#b00020" }}>
                          -{preview.deduction}
                        </div>
                      </div>
                    )}

                    <hr style={{ borderTop: "1px solid #000", margin: "8px 0" }} />

                    <div className="row mb-3">
                      <div className="col-6" style={{ fontSize: "15px", fontWeight: 700 }}>
                        Net Salary
                      </div>
                      <div className="col-6 text-end" style={{ fontSize: "15px", fontWeight: 700 }}>
                        {preview.netSalary}
                      </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                      <RegularButton
                        text="Cancel"
                        id="cancel-payment-button"
                        onClick={() => setShowPreviewModal(false)}
                        backgroundColor="#ffffff"
                        color="#282E26"
                      />
                      <RegularButton
                        text="Confirm Payment"
                        id="confirm-payment-button"
                        onClick={handleConfirmPayment}
                        backgroundColor="#282E26"
                      />
                    </div>
                  </div>
                );
              })()}
            </div>
          </ReusableModal>


          <div className="">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="mb-1">Salary History</h3>
            </div>

            <ReusableTable
              fetchData={fetchSalaryHistory}
              columns={[
                { header: "Employee", field: "payroll_employee_name" },
                { header: "Source", field: "salary_source" },
                { header: "Amount", field: "total_amount" },
                { header: "Unit", field: "salary_unit" },
                { header: "From Date", field: "start_date" },
                { header: "To Date", field: "end_date" },
                { header: "Date", field: "payroll_date" },
                { header: "Check Number", field: "cheque_no" },
                { header: "Bank", field: "bank_name" },
              ]}
              showAction={true}
              enablePagination
              onPrint={handlePrintSalary}
              onEdit={(id) => handleEdit(id, "salaryHistory")}
              onDelete={(id) => handleDelete(id, "salaryHistory")}
              loading={loading}
              refreshKey={salaryHistoryRefreshKey}
              currentPage={salaryHistoryPage}
              onPageChange={setSalaryHistoryPage}
              totalPages={salaryHistoryTotalPages}
            />
            {openPrint && printData && (
              <ReciptPrint
                open={openPrint}
                data={printData}
                // storeInfo={{
                //   store_name: user?.store_name,
                //   store_address_line1: user?.store_address,
                //   store_city: user?.city,
                //   store_state: user?.state,
                //   store_pincode: user?.pincode,
                //   store_country: user?.country,
                // }}
                onClose={() => {
                  setOpenPrint(false);
                  setPrintData(null);
                }}
              />
            )}

          </div>
        </div>
      </div>

      <ScheduleModal
        show={showScheduleModal}
        onClose={closeScheduleModal}
        selectedEmployee={selectedPayroll}
      />
    </>
  );
}
